export default __webpack_public_path__ + "static/media/időgazdálkodás.f4703015.png";